import React from 'react'
import { useDispatch } from 'react-redux'
import dayjs from '@mobi/utils/date/extendedDayjs'
import { SelectionType, toggleSelectionForGame } from '@core/Areas/Tipping/Store'
import type { ToteSportsGame } from '@core/Areas/Tipping/data/toteSports'
import {
  ButtonDrawStyled,
  ButtonGroupItemStyled,
  ButtonsContainerStyled,
  GameGroupStyled,
  GameHeaderStyled,
} from '../Common/Games.styles'
import { abbreviateName } from '../../helpers/abbreviateName'

interface GameSelectionProps {
  game: ToteSportsGame
  gameIndex: number
  isHomeSelected: boolean
  isDrawSelected: boolean
  isAwaySelected: boolean
}

export const GameSelections = ({
  game,
  gameIndex,
  isHomeSelected,
  isDrawSelected,
  isAwaySelected,
}: GameSelectionProps): JSX.Element => {
  const dispatch = useDispatch()

  const handleSelection = (gameId: string, selectionType: SelectionType) => {
    dispatch(toggleSelectionForGame({ gameId, selectionType }))
  }

  return (
    <GameGroupStyled>
      <GameHeaderStyled data-tid-tote-sport-game-header>
        <strong>Game {gameIndex + 1}</strong>{' '}
        {dayjs(game.startTime).format('ddd, DD MMM YYYY HH:mm')}
      </GameHeaderStyled>

      <ButtonsContainerStyled>
        <ButtonGroupItemStyled
          id={`${game.key}_home`}
          selected={isHomeSelected}
          onClick={() => handleSelection(game.key, 'Home')}
          data-tid-tote-sport-game-home
        >
          {abbreviateName(game.homeTeamName)}
        </ButtonGroupItemStyled>

        {game.isDrawSupported && (
          <ButtonDrawStyled
            id={`${game.key}_draw`}
            selected={isDrawSelected}
            onClick={() => handleSelection(game.key, 'Draw')}
            data-tid-tote-sport-game-draw
          >
            Draw
          </ButtonDrawStyled>
        )}

        <ButtonGroupItemStyled
          id={`${game.key}_away`}
          selected={isAwaySelected}
          onClick={() => handleSelection(game.key, 'Away')}
          data-tid-tote-sport-game-away
        >
          {abbreviateName(game.awayTeamName)}
        </ButtonGroupItemStyled>
      </ButtonsContainerStyled>
    </GameGroupStyled>
  )
}
